import { useDataLoader } from "2g-hooks/fetch";
import { useDidUpdateEffect } from "2g-hooks";

import { DATA } from "b2b/api/paths";

export default function useZadostiObsazenost({
  datumOd,
  datumDo,
  zakaznik,
  uzivatel,
  projekt,
  zdroj,
  produkt
}) {
  const canBeLoaded = Boolean(
    datumOd &&
      datumDo &&
      zakaznik &&
      uzivatel &&
      projekt &&
      zdroj &&
      produkt &&
      !produkt.bezCasu
  );
  const loader = useDataLoader({
    url: DATA.zadostiObsazenost(),
    method: "post",
    lazy: !canBeLoaded,
    payload: {
      datumOd: datumOd?.getTime && datumOd?.getTime(),
      datumDo: datumDo?.getTime && datumDo?.getTime(),
      zakaznik,
      uzivatel,
      projekt,
      zdroj,
      produkt
    }
  });

  useDidUpdateEffect(() => {
    canBeLoaded && !loader.loading && loader.loaded && loader.load();
  }, [
    datumOd?.getTime && datumOd?.getTime(),
    datumDo?.getTime && datumDo?.getTime(),
    zakaznik,
    uzivatel,
    projekt,
    zdroj,
    produkt
  ]);

  return loader;
}
